import React, { useEffect, useState, useMemo } from "react";
import {
  getUserDataOderCreate,
  AllProducts,
  productVariantEdit,
  orderCreateMyAdmin,
  getUserCardData,
  getUserCartTotal,
  DeleteCartItems,
  UpdateCartItems,
} from "services/apiService";
import {
  MenuItem,
  Card,
  CardContent,
  Typography,
  TextField,
  Box,
  Checkbox,
  List,
  ListItemText,
  Avatar,
  Grid,
  Skeleton,
  Button,
  Autocomplete,
  CircularProgress,
} from "@mui/material";
import { FixedSizeList } from "react-window";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCartShopping } from "@fortawesome/free-solid-svg-icons";
import toast from "react-hot-toast";
import Cart from "./UserCartDetails";
import selectProducts from "../../assect/Images/SelectImage.jpg";
import VariantSelectorDialog from "./VariantSelectorDialog";

const OrderCreate = () => {
  const [getUserData, setGetUserData] = useState([]);
  const [getProduct, setGetProduct] = useState([]);
  const [selectedUser, setSelectedUser] = useState(null);
  const [loadingUsers, setLoadingUsers] = useState(true);
  const [searchTermProduct, setSearchTermProduct] = useState("");
  const [selectedProducts, setSelectedProducts] = useState<string[]>([]);
  const [finalProduct, setfinalProduct] = useState(null);
  const [openUser, setOpenUser] = useState(false);
  const [varaint, setVariant] = useState([]);
  const [openModal, setOpenModal] = useState(false);
  const [selectedVariant, setSelectedVariant] = useState(null);
  const [UserCartProducts, setUserCartProducts] = useState([]);
  const [userCartTotalAmount, setUserCartTotalAmount] = useState("");
  const AppUrl = process.env.REACT_APP_IMAGE_URL;

  useEffect(() => {
    fetchUserData();
    fetchProductData();
  }, []);

  useEffect(() => {
    if (selectedUser) {
      fetchAllUserData();
    }
  }, [selectedUser]);

  const fetchAllUserData = async () => {
    if (!selectedUser) return;

    const apiCalls = [
      {
        fetchFunction: () => getUserCardData(selectedUser),
        setState: setUserCartProducts,
      },
      {
        fetchFunction: async () => {
          try {
            return await getUserCartTotal(selectedUser);
          } catch (error) {
            console.warn("Cart total API failed:", error);
            return { data: null };
          }
        },
        setState: setUserCartTotalAmount,
      },
    ];

    try {
      await Promise.all(
        apiCalls.map(async ({ fetchFunction, setState }) => {
          const response = await fetchFunction();
          if (response?.status_code === 200) {
            setState(response.data);
          } else if (response?.data === null) {
            setState(null);
          }
        })
      );
    } catch (error) {
      toast.error("An error occurred while fetching user data.");
      console.error(error);
    }
  };

  const fetchUserData = async () => {
    setLoadingUsers(true);
    try {
      const response = await getUserDataOderCreate();
      if (response.status_code === 200) {
        setGetUserData(response.data);
      }
    } catch (error) {
      console.log("Error fetching user data:", error);
    } finally {
      setLoadingUsers(false);
    }
  };

  const fetchProductData = async () => {
    try {
      const response = await AllProducts();
      if (response.status_code === 200) {
        setGetProduct(response.data);
      }
    } catch (error) {
      console.log("Error fetching product data:", error);
    }
  };

  const handleMoveToCart = (id) => {
    fetchProductVariantDropdown(id);
    setOpenModal(true);
  };

  const fetchProductVariantDropdown = async (productId: number) => {
    try {
      const response = await productVariantEdit(productId);
      if (response.status_code === 200) {
        setVariant(response.data.variants);
        setfinalProduct(productId);
      }
    } catch (error) {
      console.log(error, error);
    }
  };

  const handleAddtoCart = async () => {
    try {
      const payload = {
        product_id: finalProduct,
        quantity: 1,
        variant_id: selectedVariant,
        attribute_id: 0,
        user_id: selectedUser,
      };
      const response = await orderCreateMyAdmin(payload);
      if (response.status_code === 200) {
        toast.success(response.message);
        handleProductSelect(finalProduct);
        fetchAllUserData();
        setSelectedVariant(null);
        handleModalClose();
      }
    } catch (error) {
      toast.error("Oops, product already in cart.");
      handleModalClose();
    }
  };

  const handleUserSelect = (user) => {
    if (user) {
      setSelectedUser(user.id);
      setSelectedUser(user?.id);
      setSearchTermProduct("");
      setSelectedProducts([]);
      setOpenUser(false);
    }
    setOpenUser(false);
  };

  const handleProductSearch = (event) => {
    setSearchTermProduct(event.target.value);
  };

  const handleProductSelect = (productId: string) => {
    setSelectedProducts((prevSelected) =>
      prevSelected.includes(productId)
        ? prevSelected.filter((id) => id !== productId)
        : [...prevSelected, productId]
    );
  };

  const handleModalClose = () => {
    setOpenModal(false);
  };

  const handleVariantSelect = (variantId) => {
    setSelectedVariant(variantId);
  };

  const filteredProducts = useMemo(() => {
    return getProduct.filter((product) =>
      product.product_name
        .toLowerCase()
        .includes(searchTermProduct.toLowerCase())
    );
  }, [getProduct, searchTermProduct]);

  const renderProduct = ({ index, style }) => {
    const product = filteredProducts[index];
    return (
      <MenuItem
        key={product.product_id}
        value={product.product_id}
        style={style}
        onClick={() => handleProductSelect(product)}
      >
        <Box key={product.product_id} display="flex" alignItems="center">
          <Checkbox
            checked={selectedProducts.includes(product.product_id)}
            onChange={() => handleProductSelect(product.product_id)}
            value={product.product_id}
            name="product-select-checkbox"
            inputProps={{ "aria-label": product.product_name }}
          />
          <Avatar
            src={`${AppUrl}${product.thumnail_image || "placeholder.png"}`}
            alt={product.product_name}
            style={{ marginRight: "10px" }}
            variant="square"
          />
          <ListItemText
            primary={
              <span
                style={{
                  display: "inline-block",
                  maxWidth: "500px",
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                }}
              >
                {product.product_name}
              </span>
            }
          />
        </Box>
      </MenuItem>
    );
  };

  const handleDelete = async (id: number) => {
    try {
      const payload = {
        product_id: id,
        user_id: Number(selectedUser),
      };
      const response = await DeleteCartItems(payload);
      if (response.status_code === 200) {
        toast.success(response.message);
        fetchAllUserData();
      }
    } catch (error) {
      toast.error(error);
    }
  };

  const handleUpdate = async (productId, updatedQuantity) => {
    try {
      const payload = {
        product_id: Number(productId),
        quantity: Number(updatedQuantity),
        user_id: Number(selectedUser),
      };
      const response = await UpdateCartItems(payload);
      if (response.status_code === 200) {
        fetchAllUserData();
      }
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <>
      <div style={{ padding: "20px" }}>
        <Grid container spacing={3}>
          <Grid item xs={12} md={6}>
            <Autocomplete
              style={{ marginBottom: "20px" }}
              open={openUser}
              onOpen={() => setOpenUser(true)}
              onClose={() => setOpenUser(false)}
              options={getUserData}
              getOptionLabel={(option) => option?.name_email || ""}
              loading={loadingUsers}
              value={
                getUserData.find((user) => user.id === selectedUser) || null
              }
              onChange={(event, newValue) => handleUserSelect(newValue)}
              isOptionEqualToValue={(option, value) => option.id === value?.id}
              renderOption={(props, option) => (
                <li {...props} key={option.id}>
                  {option.name_email}
                </li>
              )}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Select User"
                  variant="outlined"
                  InputProps={{
                    ...params.InputProps,
                    endAdornment: (
                      <>
                        {loadingUsers ? (
                          <CircularProgress color="inherit" size={20} />
                        ) : null}
                        {params.InputProps.endAdornment}
                      </>
                    ),
                  }}
                />
              )}
              clearOnEscape={false}
            />

            <TextField
              fullWidth
              placeholder="Search Product"
              variant="outlined"
              onChange={handleProductSearch}
              disabled={!selectedUser}
              style={{ marginBottom: "10px" }}
            />
            <List
              style={{
                pointerEvents: selectedUser ? "auto" : "none",
                opacity: selectedUser ? 1 : 0.5,
              }}
            >
              {loadingUsers ? (
                <Skeleton height={50} />
              ) : (
                <FixedSizeList
                  height={450}
                  itemSize={50}
                  itemCount={filteredProducts.length}
                  width="100%"
                >
                  {renderProduct}
                </FixedSizeList>
              )}
            </List>
          </Grid>
          <Grid item xs={12} md={6}>
            <Typography
              sx={{
                backgroundColor: "#8aa8bfa6 ",
                color: "white",
                fontWeight: "bold",
                fontSize: "0.9rem",
                textAlign: "center",
                padding: "0.4rem",
                textTransform: "uppercase",
                boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
              }}
            >
              Selected Products
            </Typography>

            <Box
              sx={{
                marginTop: "20px",
                maxHeight: "550px",
                overflowY: "auto",
                "&::-webkit-scrollbar": {
                  width: "3px",
                },
                "&::-webkit-scrollbar-track": {
                  background: "transparent",
                },
                "&::-webkit-scrollbar-thumb": {
                  backgroundColor: "#888",
                  borderRadius: "10px",
                },
                "&::-webkit-scrollbar-thumb:hover": {
                  backgroundColor: "#555",
                },
              }}
            >
              {selectedProducts.length === 0 ? (
                <div
                  className="d-flex justify-content-center"
                  style={{ flexDirection: "column", alignItems: "center" }}
                >
                  <img src={selectProducts} width={400} alt="select_items" />
                  <p style={{ fontSize: "12px", color: "grey" }}>
                    No products selected . please select the products from the
                    list !
                  </p>
                </div>
              ) : (
                selectedProducts.map((productId) => {
                  const product = getProduct.find(
                    (product) => product.product_id === productId
                  );
                  return (
                    product && (
                      <Card
                        key={product.product_id}
                        style={{ marginTop: "10px" }}
                      >
                        <CardContent>
                          <Box
                            display="flex"
                            alignItems="center"
                            justifyContent="space-between"
                          >
                            <Avatar
                              src={`${AppUrl}${
                                product.thumnail_image || "placeholder.png"
                              }`}
                              alt="Product Image"
                              style={{ marginRight: "10px" }}
                              variant="square"
                            />
                            <Box>
                              <Typography variant="body1">
                                {product.product_name.length > 50
                                  ? `${product.product_name.substring(
                                      0,
                                      50
                                    )}...`
                                  : product.product_name}
                              </Typography>

                              <Typography variant="body2" color="textSecondary">
                                {product.price}
                              </Typography>
                            </Box>
                            <Button
                              variant="outlined"
                              color="secondary"
                              onClick={() =>
                                handleMoveToCart(product.product_id)
                              }
                            >
                              Move to &nbsp;
                              <FontAwesomeIcon icon={faCartShopping} />
                            </Button>
                          </Box>
                        </CardContent>
                      </Card>
                    )
                  );
                })
              )}
            </Box>
          </Grid>
        </Grid>
        <br />
        {selectedUser && (
          <Cart
            cartItems={UserCartProducts}
            cartTotalAmount={userCartTotalAmount}
            handleDelete={handleDelete}
            handleUpdate={handleUpdate}
            user={selectedUser}
          />
        )}
      </div>
      <VariantSelectorDialog
        openModal={openModal}
        handleModalClose={handleModalClose}
        variants={varaint}
        selectedVariant={selectedVariant}
        handleVariantSelect={handleVariantSelect}
        handleAddToCart={handleAddtoCart}
      />
    </>
  );
};

export default OrderCreate;
